import React, { CSSProperties } from 'react';

// One outcome as a rail of twenty beads: the beads pushed right are its share, so one bead is
// five per cent. Under a figure's stage class the pushed beads slide across from the left,
// rightmost first (onehot.css); the bead colour comes from the figure's --c.

// Twenty beads, with a gap of five between the two ends: short enough that the beads are as
// full as the page's other figures', long enough that the push still reads.
const GAP = 5;
const SLOTS = 20 + GAP;

export const shareLabel = (p: number) => p.toFixed(2);

export function Rail({ x0, x1, y, p, delay }: { x0: number; x1: number; y: number; p: number; delay: number }) {
  const step = (x1 - x0) / (SLOTS - 1);
  const pushed = Math.round(p * 20);
  const r = Math.min(3.1, step * 0.46);
  return (
    <g>
      <line className="oh-hair" x1={x0 - 6} y1={y} x2={x1 + 6} y2={y} />
      {Array.from({ length: 20 - pushed }, (_, k) => (
        <circle key={`r${k}`} className="oh-bead-rest" cx={x0 + k * step} cy={y} r="2" />
      ))}
      {Array.from({ length: pushed }, (_, j) => (
        <circle
          key={`p${j}`}
          className="oh-push"
          cx={x0 + (SLOTS - 1 - j) * step}
          cy={y}
          r={r}
          style={{ '--dx': `${GAP * step}px`, '--d': `${(delay + j * 0.022).toFixed(3)}s` } as CSSProperties}
        />
      ))}
    </g>
  );
}

export default Rail;
